export var RefinancingReason;
(function (RefinancingReason) {
    RefinancingReason["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReason["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReason["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReason["Construction"] = "CONSTRUCTION";
    RefinancingReason["Consolidate"] = "CONSOLIDATE_DEBT";
    RefinancingReason["Cashout"] = "GET_CASHOUT";
})(RefinancingReason || (RefinancingReason = {}));
//# sourceMappingURL=index.js.map